import { useUser } from "contexts";
import { createContext, useContext } from "react";
import { CharactersProvider } from "./CharacterContext";
import { CreateProvider } from "./CreateContext";
import useLibraryManager from "./useLibraryManager";

const Library = createContext();
const Public = createContext();

export function LibraryProvider({ children }) {
  const { profile, uid } = useUser();

  const ids = profile.storyIds;
  const { updateStory, ...ctrl } = useLibraryManager(ids);

  return (
    <Library.Provider
      value={{
        stories: uid ? ctrl.library : [],
        loading: ctrl.loadingLibrary,
        updateStory,
      }}
    >
      <CharactersProvider>
        <Public.Provider
          value={{
            all: ctrl.all,
            loading: ctrl.loadingPublic,
            stories: ctrl.public,
            addStory: ctrl.addStory,
            updateStory,
          }}
        >
          <CreateProvider>{children}</CreateProvider>
        </Public.Provider>
      </CharactersProvider>
    </Library.Provider>
  );
}

export const useLibrary = () => useContext(Library);
export const usePublic = () => useContext(Public);
